import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changeJob } from "../../features/job/jobSlice";
import { convertDate, convertStringToDate } from "../../utlis/convertDate";
import { convertToNumber } from "../../utlis/convertToNumber";

const Form = ({ job }) => {
  const { id, title, type, salary, deadline } = job || {};
  const [jobTitle, setJobTitle] = useState(title);
  const [jobType, setJobType] = useState(type);
  const [jobSalary, setJobSalary] = useState(salary);
  const [jobDeadline, setJobDeadline] = useState(deadline);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      title: jobTitle,
      type: jobType,
      salary: jobSalary,
      deadline: convertDate(jobDeadline),
    };
    dispatch(changeJob({ id, data }));
    navigate("/");
  };


  return (
    <form className="space-y-6">
      <div className="fieldContainer">
        <label
          htmlFor="lwsJobTitle"
          className="text-sm font-medium text-slate-300"
        >
          Job Title
        </label>
        <select
          id="lwsJobTitle"
          name="lwsJobTitle"
          autoComplete="lwsJobTitle"
          required
          onChange={(e) => setJobTitle(e.target.value)}
          value={jobTitle}
        >
          <option value="" hidden selected>
            Select Job
          </option>
          <option>Software Engineer</option>
          <option>Web Developer</option>
          <option>Software Developer</option>
          <option>Full Stack Developer</option>
          <option>MERN Stack Developer</option>
          <option>DevOps Engineer</option>
          <option>QA Engineer</option>
          <option>Product Manager</option>
          <option>Social Media Manager</option>
          <option>Senior Executive</option>
          <option>Junior Executive</option>
          <option>Android App Developer</option>
          <option>IOS App Developer</option>
          <option>Frontend Developer</option>
          <option>Frontend Engineer</option>
          <option>Backend Developer</option>
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lwsJobType">Job Type</label>
        <select
          id="lwsJobType"
          name="lwsJobType"
          autoComplete="lwsJobType"
          required
          onChange={(e) => setJobType(e.target.value)}
          value={jobType}
        >
          <option value="" hidden selected>
            Select Job Type
          </option>
          <option>Full Time</option>
          <option>Internship</option>
          <option>Remote</option>
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lwsJobSalary">Salary</label>
        <div className="flex border rounded-md shadow-sm border-slate-600">
          <span className="input-tag">BDT</span>
          <input
            type="number"
            name="lwsJobSalary"
            id="lwsJobSalary"
            required
            className="!rounded-l-none !border-0"
            placeholder="20,00,000"
            onChange={(e) => setJobSalary(e.target.value)}
            value={convertToNumber(jobSalary)}
          />
        </div>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lwsJobDeadline">Deadline</label>
        <input
          type="date"
          name="lwsJobDeadline"
          id="lwsJobDeadline"
          required
          onChange={(e) => setJobDeadline(e.target.value)}
          value={convertStringToDate(jobDeadline)}
        />
      </div>

      <div className="text-right">
        <input
          type="submit"
          value="Update"
          onClick={handleSubmit}
          className="lws-submit cursor-pointer btn btn-primary w-fit"
        />
      </div>
    </form>
  );
};

export default Form;
